var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B5C1DB",
    d: "M36.665 9.668a14.2 14.2 0 0 1-3.934 1.067 6.88 6.88 0 0 0 3.017-3.783 13.7 13.7 0 0 1-4.35 1.666 6.833 6.833 0 0 0-11.666 6.234 19.4 19.4 0 0 1-14.084-7.15 6.93 6.93 0 0 0-.917 3.45 6.82 6.82 0 0 0 3.034 5.683 6.75 6.75 0 0 1-3.1-.85v.084a6.83 6.83 0 0 0 5.5 6.666 6.6 6.6 0 0 1-1.834.284 8 8 0 0 1-1.283-.117 6.85 6.85 0 0 0 6.384 4.733 13.7 13.7 0 0 1-8.434 2.933 13 13 0 0 1-1.667-.1 19.3 19.3 0 0 0 10.484 3.084 19.316 19.316 0 0 0 19.517-19.467v-.883a14 14 0 0 0 3.333-3.534"
  })));
};
export default SvgTwitter;